module.exports = __webpack_public_path__ + "static/media/logo_300_2.7a10ac11.png";